export default __webpack_public_path__ + "static/media/30.84552c70.png";